import React from 'react';
import { useInView } from '../hooks/useInView';
export function ProtocolSection() {
  const {
    ref,
    isVisible
  } = useInView();
  const steps = [{
    letter: 'R',
    title: 'Reconocer el momento exacto',
    desc: '(gatillo)'
  }, {
    letter: 'E',
    title: 'Etiquetar la voz',
    desc: '(crítica / control / "cuidado torcido")'
  }, {
    letter: 'S',
    title: 'Separar voz de valor',
    desc: '(pensamiento ≠ verdad)'
  }, {
    letter: 'P',
    title: 'Probar evidencia real',
    desc: '(hechos del día)'
  }, {
    letter: 'O',
    title: 'Ordenar prioridades',
    desc: '(3-2-1)'
  }, {
    letter: 'N',
    title: 'Negociar con el día real',
    desc: '(mínimo viable, sin vergüenza)'
  }, {
    letter: 'D',
    title: 'Decidir 1 acción suficiente',
    desc: '(cierra el bucle)'
  }, {
    letter: 'E',
    title: 'Ejecutar cierre',
    desc: '(ritual anti-rumiación)'
  }];
  return <section ref={ref} className="w-full bg-navy py-10 px-6 md:py-14" data-id="element-211">
      <div className={`max-w-3xl mx-auto fade-in-section ${isVisible ? 'is-visible' : ''}`} data-id="element-212">
        <div className="text-center mb-10" data-id="element-213">
          <h2 className="font-serif text-3xl md:text-5xl text-gold mb-4" data-id="element-214">
            La solución: el Protocolo R.E.S.P.O.N.D.E.
          </h2>
          <p className="font-sans text-lg md:text-xl text-white/80 max-w-2xl mx-auto" data-id="element-215">
            No es motivación. No es cursilería. Es un protocolo para momentos
            reales. Cuando aparezca el "deberías", tú haces esto:
          </p>
        </div>

        <div className="grid gap-3 md:gap-4" data-id="element-216">
          {steps.map((step, idx) => <div key={idx} className={`flex items-center bg-white/5 border border-gold/20 p-3 md:p-4 rounded-lg stagger-item ${isVisible ? 'is-visible' : ''}`} style={{
          transitionDelay: `${idx * 100}ms`
        }} data-id="element-217">
              <div className="flex-shrink-0 w-11 h-11 md:w-14 md:h-14 flex items-center justify-center bg-gold/10 rounded-full border border-gold text-gold font-serif font-bold text-xl md:text-2xl mr-3 md:mr-5" data-id="element-218">
                {step.letter}
              </div>
              <div data-id="element-219">
                <h3 className="font-serif text-lg md:text-xl text-white font-medium" data-id="element-220">
                  {step.title}
                </h3>
                <p className="font-sans text-sm md:text-base text-white/60" data-id="element-221">
                  {step.desc}
                </p>
              </div>
            </div>)}
        </div>

        <div className="mt-10 text-center p-5 border border-gold/30 rounded-lg bg-gold/5" data-id="element-222">
          <p className="font-serif text-xl md:text-2xl text-gold italic" data-id="element-223">
            "Resultado: la culpa baja porque ya no se queda 'flotando'. Se
            convierte en decisión, evidencia, prioridad y cierre."
          </p>
        </div>
      </div>
    </section>;
}